import classNames from 'classnames';
import React from 'react';

import { DropboxAttachment } from './DropboxAttachment';
import { Icon, IconName } from 'app/common/components/controls';
import styles from './DropboxSection.less';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('dropbox_section');

const dropboxMark = require('resources/images/dropbox-mark.svg');

interface Attachment {
  id: string;
  date: string;
  name: string;
  url: string;
}

interface DropboxSectionProps {
  dropboxAttachments: Attachment[];
  suggest: boolean;
  onDismiss: (target: EventTarget) => void;
  onRemoveAttachment: (idAttachment: string) => void;
  onEnable: (target: EventTarget) => void;
}

export const DropboxSection: React.FunctionComponent<DropboxSectionProps> = ({
  dropboxAttachments,
  suggest,
  onDismiss,
  onRemoveAttachment,
  onEnable,
}) => {
  if (!suggest) {
    return null;
  }

  if (dropboxAttachments.length === 0) {
    return null;
  }

  return (
    <div className="window-module">
      <div className={styles.moduleTitleBlock}>
        <img
          className={styles.dropboxMark}
          src={dropboxMark}
          height="24"
          width="24"
          alt="Dropbox"
        />
        <div className={styles.headerContent}>
          <h3 className={styles.moduleTitle}>{format('dropbox')}</h3>
          <div className={styles.headerActions}>
            <button
              className={classNames(styles.headerBtn, styles.dismissBtn)}
              onClick={(e) => onDismiss(e.target)}
            >
              <Icon name={IconName.Close} />
            </button>
            <button
              className={classNames(styles.headerBtn, styles.enableDropboxBtn)}
              onClick={(e) => onEnable(e.target)}
            >
              <img
                className={styles.whiteDropboxMark}
                src={dropboxMark}
                height="20"
                width="20"
                alt=""
              />
              <span>{format('enable-dropbox')}</span>
            </button>
          </div>
        </div>
      </div>
      <div className="u-gutter">
        <p className={styles.sectionMeta}>{format('dropbox-overview')}</p>
        <div className={styles.attachmentsGrid}>
          {dropboxAttachments.map((attachment) => (
            <DropboxAttachment
              key={attachment.id}
              attachment={attachment}
              onRemoveAttachment={onRemoveAttachment}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
